export const colors = [
  "BlanchedAlmond",
  "HoneyDew",
  "Lavender",
  "PowderBlue",
  "LightCyan",
  "LightYellow",
];